// import { useState, useEffect } from "react";
import { useRef, useState, useMemo, useEffect } from "react";
import { Modal, Frame, TitleBar, Button, Tooltip, Input } from "@react95/core";
import { useLocalString, useLocalNumber } from "../../hooks/useLocalStorage";
import { HorizDivider } from "../UI/Dividers";

import {
  Textchat,
  Mailnews12,
  BatExec2,
  FilePick,
  Mailnews8,
  HelpBook,
  Wab321011,
  Awfext326053,
  Wmsui323911,
  Msnstart1,
  Progman21,
  Smmscrpt100,
  Wmsui321306,
  Shell32147,
  User,
} from "@react95/icons";

import { useApp } from "../../context/AppContext";

import { WINDOW_NAMES } from "../../config/const";
import { getModalSizeProps } from "../../config/window";

export const UserInfoDef = {
  id: WINDOW_NAMES.UserInfo,
  title: "User Info",
  icon: <User variant="16x16_4" />,
  hasButton: true,
};

export default function UserInfo() {
  const { openModal, closeModal } = useApp();

  const icon = useMemo(() => UserInfoDef.icon, []);
  const sizeProps = useMemo(() => getModalSizeProps("300px", "225px", "centered"), []);

  // local user settings persisted to localstorage
  const [savedUsername, setSavedUsername] = useLocalString("username", "");
  const [savedAvatar, setSavedAvatar] = useLocalNumber("avatarIndex", 0);
 
  // ui state
  const [input, setInput] = useState<string>(savedUsername ?? "");
  const [status, setStatus] = useState<string>("");

  // available avatar icons (click cycles)
  const avatars = [User, Msnstart1, Shell32147, Progman21];

  const isValid = /^[a-z0-9]{1,4}$/.test(input);

  // keep input synced when saved username changes externally
  useEffect(() => {
    setInput(savedUsername ?? "");
  }, [savedUsername]);

  return (
    <Modal
      key={UserInfoDef.id}
      id={UserInfoDef.id}
      icon={icon}
      title={UserInfoDef.title}
      dragOptions={sizeProps.dragOptions}
      defaultClosed={true}
      hasWindowButton={UserInfoDef.hasButton}
      titleBarOptions={[
        // <Modal.Minimize key="minimize" />,
        <TitleBar.Close key="close" onClick={() => closeModal(UserInfoDef.id)} />,
      ]}
      height={sizeProps.height}
      width={sizeProps.width}
    >
      <Frame
        // padding="8px"
        paddingTop="16px"
        boxShadow="$in"
        overflow="auto"
        backgroundColor="#fff"
        flexGrow={1}
        fontSize="14px"
        style={{
          flex: 1,
          textAlign: "center",
          display: "flex",
          flexDirection: "column",
          gap: "8px",
          height: "100%",
          paddingLeft: "6px",
          paddingRight: "6px",
          // paddingBottom: "16px",
        }}
      >
        <div style={{ display: "flex", flexDirection: "column", gap: 6, alignItems: "center" }}>
          <div style={{ fontWeight: 600 }}>Username</div>

          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <Input
              value={input}
              onChange={(e: any) => {
                const v = String(e.target.value || "");
                const sanitized = v.toLowerCase().replace(/[^a-z0-9]/g, "").slice(0, 4);
                setInput(sanitized);
              }}
              placeholder="a-z / 0-9, up to 4 chars"
              style={{ width: "80px" }}
            />
            <Button
              disabled={!(isValid && input !== (savedUsername ?? ""))}
              onClick={() => {
                setSavedUsername(input);
                setStatus("saved");
                setTimeout(() => setStatus(""), 1500);
              }}
            >
              Save
            </Button>
          </div>

          {status === "saved" ? <div style={{ color: "green" }}>Saved!</div> : null}

          <div style={{ fontSize: 12, color: "#333" }}>Setting your username here will make you visible on the scoreboard.</div>
        </div>

        <div style={{ width: "100%" }}>
          <HorizDivider />
        </div>

        <div style={{ display: "flex", flexDirection: "column", gap: 6, alignItems: "center" }}>
          <div style={{ fontWeight: 600 }}>Avatar</div>

          <div style={{ display: "flex", alignItems: "center", gap: 12, justifyContent: "center", flexDirection: "column" }}>
            <Button
              style={{ width: 72, height: 72, display: "flex", alignItems: "center", justifyContent: "center" }}
              onClick={() => {
                const next = ((savedAvatar ?? 0) + 1) % avatars.length;
                setSavedAvatar(next);
                setStatus("avatar saved");
                setTimeout(() => setStatus(""), 1200);
              }}
            >
              {(() => {
                const AvatarIcon = avatars[savedAvatar ?? 0];
                return <AvatarIcon variant="32x32_4" />;
              })()}
            </Button>
            <div style={{ fontSize: 12, color: "#333" }}>click avatar to change</div>
          </div>
        </div>
      </Frame>
    </Modal>
  );
}
